import React, { useEffect } from "react";
import { Input } from "@/components/ui/input";
import { useFormField } from "@/components/ui/form";
import { Combobox } from "@/components/ui/combobox";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";


// Custom Input component that shows error state
export const FormInput = React.forwardRef<HTMLInputElement, React.ComponentPropsWithoutRef<typeof Input>>(
    ({ className, ...props }, ref) => {
        const { error } = useFormField();
        return (
            <Input
                ref={ref}
                className={cn(
                    className,
                    error && "border-destructive focus-visible:ring-destructive"
                )}
                {...props}
            />
        );
    }
);
FormInput.displayName = "FormInput";

// Custom Combobox wrapper that shows error state
export const FormCombobox = <T extends string>({
    className,
    ...props
}: React.ComponentPropsWithoutRef<typeof Combobox<T>>) => {
    const { error } = useFormField();
    return (
        <Combobox
            className={cn(
                className,
                error && "[&>button]:border-destructive"
            )}
            {...props}
        />
    );
};

// Custom Textarea component that shows error state
export const FormTextarea = React.forwardRef<HTMLTextAreaElement, React.ComponentPropsWithoutRef<typeof Textarea>>(
    ({ className, ...props }, ref) => {
        const { error } = useFormField();
        return (
            <Textarea
                ref={ref}
                className={cn(
                    className,
                    error && "border-destructive focus-visible:ring-destructive"
                )}
                {...props}
            />
        );
    }
);
FormTextarea.displayName = "FormTextarea";
